import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from '../api/axios';
import { AuthContext } from './AuthContext';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated) {
      loadCart();
    }
  }, [isAuthenticated]);

  const loadCart = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/cart');
      setCart(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const addToCart = async (giftCardId, quantity = 1) => {
    try {
      const res = await axios.post('/api/cart', { giftCardId, quantity });
      setCart(res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.msg || 'Failed to add to cart' };
    }
  };

  const updateCartItem = async (giftCardId, quantity) => {
    try {
      const res = await axios.put(`/api/cart/${giftCardId}`, { quantity });
      setCart(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const removeFromCart = async (giftCardId) => {
    try {
      const res = await axios.delete(`/api/cart/${giftCardId}`);
      setCart(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const clearCart = async () => {
    try {
      const res = await axios.delete('/api/cart');
      setCart(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const getCartTotal = () => {
    return cart.reduce((total, item) => {
      if (item.giftCard && item.giftCard.denominations && item.giftCard.denominations.length > 0) {
        return total + (item.giftCard.denominations[0].priceUSD * item.quantity);
      }
      return total;
    }, 0);
  };

  return (
    <CartContext.Provider value={{
      cart,
      loading,
      addToCart,
      updateCartItem,
      removeFromCart,
      clearCart,
      getCartTotal,
      cartCount: cart.length
    }}>
      {children}
    </CartContext.Provider>
  );
};
